/**
 * Tiny module-level event bus for "concept-card progress may have changed".
 *
 * Axios response interceptor calls notifyProgressBus() after any server
 * action known to fan out mastery credit (completions, boss wins, etc).
 * React-land subscribes from ConceptBuilderContext and re-publishes as a
 * state timestamp so components can put it in useEffect deps and refetch.
 */

const listeners = new Set();

export function subscribeProgressBus(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function notifyProgressBus() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch {
      /* listener errors must not block the bus */
    }
  });
}

// URL patterns that fan out concept-card mastery on success. Matched
// against the request path (without host/query). Kept broad on purpose —
// the refetch is idempotent and cheap, so overmatching is fine.
const MASTERY_FANOUT_URL_PATTERNS = [
  /\/level-progress\/.+\/objective\/\d+\/complete$/,
  /\/level-progress\/.+\/objective\/\d+\/content\/complete$/,
  /\/level-progress\/.+\/objective\/\d+\/trial\/complete$/,
  /\/level-progress\/.+\/objective\/\d+\/fountain\/(complete|answer)$/,
  /\/level-progress\/.+\/objective\/\d+\/drill\/(complete|answer)$/,
  /\/level-progress\/.+\/boss\/complete$/,
  /\/level-progress\/main-boss\/complete$/,
  /\/batch\/.*(complete|win)\b/,
  /\/concept-cards\/[^/]+\/drill-result$/,
  /\/concept-cards\/drill\/answer$/,
  /\/dlc\/[^/]+\/carousel\/drill-complete$/,
];

export function urlTriggersProgressBus(url) {
  if (!url) return false;
  return MASTERY_FANOUT_URL_PATTERNS.some((re) => re.test(url));
}
